import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import * as jwtDecode from 'jwt-decode'; // Import a library for decoding JWT tokens
import AppRoutes from './AppRoutes';
import TauriLayout from './components/TauriLayout/TauriLayout';
import { FilterProvider } from './components/TauriGlobalContext/TauriGlobalContext';
import PageNotFound from './PageNotFound/PageNotFound';

const App = () => {
  const { pathname } = useLocation();

  // Store the last visited route in localStorage
  useEffect(() => {
    localStorage.setItem('lastNavigated', pathname);
  }, [pathname]);

  // Retrieve the last visited route from localStorage
  const lastNavigated = localStorage.getItem('lastNavigated');

  return (
    <FilterProvider>
      <TauriLayout>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} {...rest} element={element} />;
          })}
        </Routes>
      </TauriLayout>
    </FilterProvider>
  );
};

export default App;